// src/components/WhatsAppFloat.jsx
import React from "react";
import "./WhatsAppFloat.css";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppFloat = ({ phoneNumber }) => {
  // remove all non-digits
  const cleanNumber = phoneNumber.replace(/\D/g, "");

  // WhatsApp-safe link (fixes Desktop Beta issue)
  const link = `https://api.whatsapp.com/send?phone=${cleanNumber}`;

  return (
    <a
      href={link}
      className="wa-float"
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp className="wa-icon" />
    </a>
  );
};

export default WhatsAppFloat;
